import { Observable } from "rxjs";
import { IDeliveryNotifications } from "../interfaces/IDeliveryNotifications";
import { ApiEndpointResolver } from "./apiEndpointResolver";
import HttpClient from "./httpClient";
import StorageService from "./storageService";

const STORAGE_KEY = "__DeliveriesViewed__";

interface IDeliveryNotificationState {
  viewedDateTime: number;
  notificationCount: number;
}

function isDifferentDay(lhs: Date, rhs: Date): boolean {
  if (
    lhs.getDate() !== rhs.getDate() &&
    lhs.getFullYear() !== rhs.getFullYear() &&
    lhs.getMonth() !== rhs.getMonth()
  ) {
    return true;
  }

  return false;
}

const DeliveryNotificationService = {
  markAsViewed(currentNotificationCount: number): void {
    let state: IDeliveryNotificationState = {
      notificationCount: currentNotificationCount,
      viewedDateTime: Date.now(),
    };
    StorageService.setItem(STORAGE_KEY, JSON.stringify(state));
  },
  isViewed(currentNotificationCount: number): boolean {
    let value = StorageService.getItem(STORAGE_KEY);

    if (!value) {
      return false;
    }

    let state: IDeliveryNotificationState = JSON.parse(value);

    if (
      state.notificationCount !== currentNotificationCount ||
      isDifferentDay(new Date(state.viewedDateTime), new Date(Date.now()))
    ) {
      return false;
    }

    return true;
  },
  getDeliveryNotifications(): Observable<IDeliveryNotifications> {
    return HttpClient.get({
      baseUri: ApiEndpointResolver.getDeliveryNotificationsUrl(),
    });
  },
};

export default DeliveryNotificationService;
